import { ReactNode } from 'react'

const ConceptContainer = ({ children }: { children: ReactNode }) => {
  return <div className="flex justify-center">{children}</div>
}

export default ConceptContainer
